import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { ExportTableComponent } from 'src/app/shared/components/dover/export-table/export-table.component';

@Component({
  selector: 'app-generic-filter',
  templateUrl: './generic-filter.component.html',
  styleUrls: ['./generic-filter.component.css']
})
export class GenericFilterComponent implements OnInit {

  @Input() tabData: any;
  @Input() exportNeeded: boolean = true;
  @Output() genericFilter = new EventEmitter<any>();
  pageSizeLimit: any = [];
  periodList: any = [{ id: 'today', name: 'Today' }, { id: '7days', name: 'Last 7 days' }, { id: 'thismonth', name: 'This month' }, { id: 'lastmonth', name: 'Last month' },
  { id: '3months', name: 'Last 3 months' }, { id: '6months', name: 'Last 6 months' }];
  pageSize = new FormControl();
  period = new FormControl();
  startTime: any;
  endTime: any;
  today: any = new Date();
  trlConfig: any;
  constructor(public service: ServicecallService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.pageSizeLimit = this.service.getConfiguration('pageLimits') ? this.service.getConfiguration('pageLimits')?.pageLimits : [];
    // this.periodList = this.service.getConfiguration('periodData') ? this.service.getConfiguration('periodData')?.periodData : [];
    this.trlConfig = this.service.getConfiguration('tenantGenericConfig') ? this.service.getConfiguration('tenantGenericConfig') : null;
    this.pageSizeLimit?.length ? this.pageSize.setValue(this.pageSizeLimit[0]) : '';
    this.periodList?.length ? this.period.setValue(this.periodList[0]) : '';
    this.onPeriodFilterChange();
  }

  onPageLimitChange() {
    this.genericFilter.emit({ startTime: this.startTime, endTime: this.endTime, pageSize: this.pageSize?.value });
  }

  onPeriodFilterChange() {
    this.endTime = null;
    switch (this.period?.value?.id) {
      case 'today':
        this.startTime = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 0, 0, 0, 999);
        break;
      case '7days':
        this.startTime = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7, 0, 0, 0, 999);
        break;
      case 'thismonth':
        this.startTime = new Date(this.today.getFullYear(), this.today.getMonth(), 1, 0, 0, 0, 999);
        break;
      case 'lastmonth':
        this.startTime = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1, 0, 0, 0, 999);
        this.endTime = new Date(new Date().getFullYear(), new Date().getMonth(), 0, 23, 59, 59, 999);
        break;
      case '3months':
        this.startTime = new Date(this.today.getFullYear(), this.today.getMonth() - 3, 1, 0, 0, 0, 999);
        break;
      case '6months':
        this.startTime = new Date(this.today.getFullYear(), this.today.getMonth() - 6, 1, 0, 0, 0, 999);
        break;
      case '15mins':
        this.startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 15));
        break;
      case '30mins':
        this.startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 30));
        break;
      case '1hr':
        this.startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 60));
        break;
    }
    this.genericFilter.emit({ startTime: this.startTime, endTime: this.endTime, pageSize: this.pageSize?.value });
  }

  exportData() {
    const item = { patientId: this.tabData?.uniqueId, patientName: this.tabData?.name, _id: this.tabData?._id, site: this.tabData?.site }
    const dialogRef = this.dialog.open(ExportTableComponent, {
      disableClose: true,
      data: { msg: 'export', exportDetails: item }
    });
  }
}
